module.exports = __webpack_public_path__ + "img/fd_90.424d2659.png";